import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortBy_shared',
    standalone: false
})
export class SortBySharedPipe implements PipeTransform {
  transform<T extends {[key: string]: any} | number | string>(value: T[] | null, order?: 'asc' | 'desc', column?: keyof T) {
    if (!value || !Array.isArray(value)) return [];
    if (value.length <= 1) return value;

    const isDesc = order === 'desc';

    const sortedArray = [...value];
    if (!column || column === '') {
      sortedArray.sort((a, b) => {
        const aa = isDesc ? b : a;
        const bb = isDesc ? a : b;
        const isNumeric = typeof aa === 'number' && typeof bb === 'number';
        return isNumeric ? aa - bb : `${aa}`.localeCompare(`${bb}`);
      })
    } else {
      sortedArray.sort((a, b) => {
        const aa = isDesc ? b[column] : a[column];
        const bb = isDesc ? a[column] : b[column];
        const isNumeric = typeof aa === 'number' && typeof bb === 'number';
        return isNumeric ? aa - bb : `${aa}`.localeCompare(`${bb}`);
      })
    }
    return sortedArray;
  }
}